import { useCallback, useState } from "react";
import { readStorage, writeStorage } from "../utils/storageUtils";

/**
 * useState backed by localStorage, safe against unavailable storage and
 * malformed/tampered JSON. `validate` should return false to reject a stored
 * value and fall back to `initialValue`; `sanitize` (optional) cleans a value
 * that passed validation before it reaches state.
 */
export function useLocalStorage(key, initialValue, validate, sanitize) {
  const [value, setValue] = useState(() => readStorage(key, initialValue, validate, sanitize));

  const update = useCallback(
    (next) => {
      setValue((prev) => {
        const resolved = typeof next === "function" ? next(prev) : next;
        writeStorage(key, resolved);
        return resolved;
      });
    },
    [key]
  );

  return [value, update];
}
